import * as React from 'react';

import { SVGProps } from '../../types';

export const IconExclamationTriangleSvg = ({
  title,
  titleId,
  ...props
}: SVGProps) => (
  <svg
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="#fff" fillOpacity=".01" d="M0 0h24v24H0z" />
    <path
      fill="#eb5f5f"
      fillRule="evenodd"
      d="M9.277 3.839c1.129-2.09 4.122-2.1 5.267-.02l7.009 12.734c1.1 2-.346 4.447-2.628 4.447H5.032c-2.272 0-3.72-2.428-2.64-4.427z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.5 8a.5.5 0 0 0-.5.5V12a1 1 0 1 0 2 0V8.5a.5.5 0 0 0-.5-.5zm.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
      clipRule="evenodd"
    />
  </svg>
);
